import React, { useEffect, useRef, useState } from 'react';
import Loader from '../../common/Loader';
import MessageInfo from '../../common/MessageInfo';
import { getAllAgg } from '../../data/data';
import { useFetchMatch } from '../../data/fetchMatch';
import { parseMacroGruppi } from '../../data/parseMacroGruppi';
import { getMatchStreamingProps } from '../../data/streaming/streamingUtils';
import { getConfiguration, getMatchIdOrStageId, getPrincipaleOPrimoGruppo, getPrincipaleOPrimoMacroGruppo } from '../../data/utils';
import { isWidgetEnabled, WidgetContext } from '../../data/widgets/WidgetContext';
import { getLabel } from '../../InitData';
import LiveCompetition from './LiveCompetition';

export const FavoriteMarketsContext = React.createContext(null);

function findAggregata(sportId) {
    const agg = getAllAgg(true, sportId);
    return agg.idAggregata;
}

function LiveSuiteCompetition(props) {
    const widgetContext = React.useContext(WidgetContext);
    const conf = getConfiguration();
    const match = props.match;

    const firstRender = useRef(true);

    let initState = (() => {
        if (firstRender.current === true) {
            firstRender.current = false;
        } else {
            return;
        }

        let favorites = localStorage.getItem('favorite_markets');
        if (favorites != null) {
            favorites = JSON.parse(favorites);
        } else {
            favorites = {};
        }

        if (favorites[props.match.sportRef] !== undefined) {
            return {
                showLoader: true,
                reload: false,
                macrogruppo: null,
                aggregataToFetch: findAggregata(match.sportRef),
                aggregata: null,
                data: null,
                matchToFetch: match,
                match: null,
                landOnFavorites: true,
                setFavoritesAsSelected: true,
                favoritesSelected: false,
                favorites
            };
        } else {
            return {
                showLoader: true,
                reload: false,
                macrogruppo: null,
                aggregataToFetch: findAggregata(match.sportRef),
                aggregata: null,
                data: null,
                matchToFetch: match,
                match: null,
                landOnFavorites: false,
                setFavoritesAsSelected: null,
                favoritesSelected: false,
                favorites
            };
        }
    })();

    const [state, setState] = useState({
        ...initState,
        update(updt) {
            setState(prev => {
                return {...prev, ...updt};
            });
        },
        setShowLoader(showLoader) {
            this.update({showLoader});
        },
        setData(data) {
            let macrogruppo = this.macrogruppo;
            if (macrogruppo == null && data.macrogruppi && data.macrogruppi.length > 0) {
                macrogruppo = getPrincipaleOPrimoMacroGruppo(data.macrogruppi);
            }
            if (this.setFavoritesAsSelected != null) {
                if (this.setFavoritesAsSelected === true) {
                    // I check whether there's any bets matching the favorite markets
                    let favorites = [];
                    try {
                        favorites = data.bets.filter(bet => {
                            return this.isMarketFavorite(this.matchToFetch.sportRef, bet.id + '_' + bet.handicap) && bet.hasOdds;
                        });
                    } catch (e) {
                        console.error(e);
                    }
                    // If there are none, I show to the main bet group as selected by filtering only the bets that don't belong to it
                    if (this.landOnFavorites && favorites.length === 0) {
                        this.update({showLoader: false, macrogruppo, aggregata: this.aggregataToFetch, data, match: this.matchToFetch, landOnFavorites: false, favoritesSelected: false, setFavoritesAsSelected: null});
                    } else {
                        this.update({showLoader: false, macrogruppo, aggregata: this.aggregataToFetch, data, match: this.matchToFetch, landOnFavorites: false, favoritesSelected: true, setFavoritesAsSelected: null});
                    }
                } else {
                    this.update({showLoader: false, macrogruppo, aggregata: this.aggregataToFetch, data, match: this.matchToFetch, landOnFavorites: false, favoritesSelected: false, setFavoritesAsSelected: null});
                }
            } else {
                if (data.gruppoById[this.aggregataToFetch] == null) {
                    const ag = getPrincipaleOPrimoGruppo(data.gruppiScommessa);
                    this.update({showLoader: false, macrogruppo, aggregata: ag, aggregataToFetch: ag.idAggregata, match: this.matchToFetch});                    
                } else {
                    this.update({showLoader: false, macrogruppo, aggregata: this.aggregataToFetch, data, match: this.matchToFetch});
                }
            }
        },
        changeMacrogruppo(macrogruppo) {
            const aggregataToFetch = getPrincipaleOPrimoGruppo(macrogruppo.aggregate).idAggregata;
            if (this.macrogruppo == null || macrogruppo.id !== this.macrogruppo.id) {
                this.update({showLoader: false, macrogruppo, aggregataToFetch, setFavoritesAsSelected: false});
            } else {
                this.update({showLoader: false, macrogruppo, aggregataToFetch, setFavoritesAsSelected: true});
            }
        },
        changeAggregata(aggregataToFetch) {
            if (aggregataToFetch !== this.aggregataToFetch) {
                this.update({aggregataToFetch, setFavoritesAsSelected: false});
            } else if (this.favoritesSelected) {
                this.update({favoritesSelected: false});
            }
        },
        changeMatch(matchToFetch) {
            const macrogruppo = null;
            let aggregataToFetch = null;
            const macrogruppi = parseMacroGruppi(matchToFetch.gruppoById, match.sportRef, matchToFetch.isLive);
            if (macrogruppi.length > 1) {
                const mg = getPrincipaleOPrimoMacroGruppo(macrogruppi);
                aggregataToFetch = getPrincipaleOPrimoGruppo(mg.aggregate).idAggregata;
            } else {
                aggregataToFetch = findAggregata(matchToFetch.sportRef);
            }
            if (this.showFavoritesForSport(matchToFetch.sportRef)) {    
                this.update({macrogruppo, aggregataToFetch, matchToFetch, landOnFavorites: true, setFavoritesAsSelected: true});
            } else {
                this.update({macrogruppo, aggregataToFetch, matchToFetch, setFavoritesAsSelected: false});
            }
        },
        toggleFavorites() {
            // this.update({favoritesSelected: !this.favoritesSelected});
            let ag = this.match.gruppiScommessa.find(bet => bet.idAggregata < 0);
            if (ag === undefined) {
                ag = this.data.gruppiScommessa.find(ag => ag.idAggregata < 0);
            }
            const aggregataToFetch = ag.idAggregata;
            if (this.aggregata !== aggregataToFetch) {
                if (this.favoritesSelected) {
                    this.update({macrogruppo: null, aggregataToFetch, setFavoritesAsSelected: false});
                } else {
                    this.update({aggregataToFetch, setFavoritesAsSelected: true});
                }
            } else {
                this.update({favoritesSelected: true});
            }
        },
        toggleFavorite(sportId, betId) {
            if (this.favorites[sportId] === undefined) {
                this.favorites[sportId] = {};
                this.favorites[sportId][betId] = true;
            } else {
                if (this.favorites[sportId][betId] === undefined) {
                    this.favorites[sportId][betId] = true;
                } else {
                    delete this.favorites[sportId][betId];
                    if (Object.keys(this.favorites[sportId]).length === 0) {
                        delete this.favorites[sportId];
                    }
                }
            }
            if (Object.keys(this.favorites).length > 0) {
                this.update({favorites: {...this.favorites}});
                localStorage.setItem('favorite_markets', JSON.stringify(this.favorites));
            } else {
                this.update({favorites: {}, favoritesSelected: false});
                localStorage.removeItem('favorite_markets');
            }
        },
        showFavoritesForSport(sportId) {
            return this.favorites[sportId] !== undefined;
        },
        isMarketFavorite(sportId, betId) {
            return this.favorites[sportId] !== undefined && this.favorites[sportId][betId] !== undefined;
        },
        setToOffAfterFetch(toggleOffAfterFetch) {
            this.update({toggleOffAfterFetch});
        }
    });
    
    function changeMacrogruppo(mg) {
        state.changeMacrogruppo(mg);
    }

    function changeAggregata(ag) {
        state.changeAggregata(ag);
    }

    useEffect(function() {
        state.changeMatch(props.match);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.match]);

    const [request, , isSetInterval] = useFetchMatch(state.matchToFetch, state.aggregataToFetch, true, false, true);

    useEffect(() => {
        if (state.match != null) {
            if (isWidgetEnabled(state.match.sportRef,state.match.widgetType,state.match.geniusId,state.match.lsportWidgetId)) {
                widgetContext.setWidget({
                    widgetSportId: state.match.sportRef,
                    widgetProviderType: state.match.widgetType,
                    widgetGeniusId: state.match.geniusId,
                    widgetLsportId: state.match.lsportWidgetId,
                    widgetMatchId: getMatchIdOrStageId(state.match),
                    widgetContainerId: '#collassaWidgetCompetition',
                    widgetStartCollapsed: true
                });
            } else {
                widgetContext.reset();
            }
        }
    }, [state.match]);

    useEffect(function() {
        let timeout = null;
        if (request.isLoading) {
            timeout = setTimeout(function() {
                state.setShowLoader(true);
            }, conf.lspt);
        } else {
            clearTimeout(timeout);
            if (!request.isError) {
                state.setData(request.data);
            } else {
                state.setShowLoader(true);
            }
        }

        return () => {
            clearInterval(timeout);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [request]);

    if (!isSetInterval && state.showLoader) {
        return <Loader error={request.isError} />;
    } else if (state.data == null || Object.keys(state.data).length === 0) {
        return (
            <MessageInfo message={getLabel('general.evento') + ' ' + getLabel('general.chiuso')} />
        )
    }

    const streamingMap = getMatchStreamingProps(state.match);
    return (
        <FavoriteMarketsContext.Provider value={state}>
            <LiveCompetition {...state.match} {...state.data} aggregata={state.aggregata} setAggregata={changeAggregata} macrogruppo={state.macrogruppo} setMacrogruppo={changeMacrogruppo} streaming={streamingMap && streamingMap[state.match.id]} isLive={true} isLiveSuite={true} isAgendaStreamingCompetition={props.isAgendaStreamingCompetition} />
        </FavoriteMarketsContext.Provider>
    );
}
            
export default LiveSuiteCompetition;